import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/components/header/header.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reviews"] */ "/vercel/path0/src/components/numbers-and-reviews/reviews/reviews.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pricing"] */ "/vercel/path0/src/components/pricing/pricing.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingSummary"] */ "/vercel/path0/src/components/pricingSummary/pricingSummary.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustedBy"] */ "/vercel/path0/src/components/trustedBy/trustedBy.comp.tsx");
